import { useTooltip } from '@frontend/design-system';

export const WithTooltip = ({ children, tooltipText }: { children: React.ReactNode; tooltipText?: string }) => {
  const { Tooltip, tooltipProps, triggerProps } = useTooltip();

  return (
    <div {...triggerProps}>
      {children}
      {tooltipText && <Tooltip {...tooltipProps}>{tooltipText}</Tooltip>}
    </div>
  );
};
